import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=1246100b&scoped=true"
import script from "./EmployeeList.vue?vue&type=script&lang=ts"
export * from "./EmployeeList.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeList.vue?vue&type=style&index=0&id=1246100b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1246100b",
  null
  
)

export default component.exports